import { AIRMASK_GREEN } from '../constants/colors';

// Category color constants
export const CATEGORY_COLORS = {
  Manage: {
    theme: 'primary' as const,
    hex: AIRMASK_GREEN, // green
  },
  TimeForMoney: {
    theme: 'secondary' as const,
    hex: '#FF6B35', // orange
  },
  Create: {
    theme: 'info' as const,
    hex: '#29b6f6', // blue - matches MUI dark mode info.main
  },
  Learn: {
    theme: 'warning' as const,
    hex: '#ffa726', // amber - matches MUI dark mode warning.main
  },
  default: {
    theme: 'default' as const,
    hex: '#9e9e9e', // grey
  },
} as const;

// Utility function to get consistent category colors across components
export const getCategoryColor = (category: string): 'primary' | 'secondary' | 'info' | 'warning' | 'default' => {
  return CATEGORY_COLORS[category as keyof typeof CATEGORY_COLORS]?.theme || CATEGORY_COLORS.default.theme;
};

// Get hex color values for categories (for use in charts)
export const getCategoryHexColor = (category: string): string => {
  return CATEGORY_COLORS[category as keyof typeof CATEGORY_COLORS]?.hex || CATEGORY_COLORS.default.hex;
};
